
import { ApiService } from './ApiService.js'
import { complexitySchema } from './PasswordValidator'

const apiInstance = new ApiService()
export {
    apiInstance,
    complexitySchema
}
